// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + "06750665" + "." + "7c5c9bf7f254bc65" + ".js";
};